module.exports = __webpack_public_path__ + "images/81d3d45309e7706efebf568c731ae651-IMG_4271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/IMG_4271.jpg
// module id = ./src/assets/images/slides/living/IMG_4271.jpg
// module chunks = 0